import { GuideSeisanSubmittedType } from '@/constants';
import { Tag } from 'antd';
import React from 'react';

type Props = { status: any };

export default function SeisanFileSubmittedTag({ status }: Props) {
  return <Tag color={GuideSeisanSubmittedType.__getColor(status)}>{GuideSeisanSubmittedType.__getLabel(status)}</Tag>;
}
